import { resolveRequest, TAsyncRequestResult } from 'utility-tools/module/requests'
import axios from 'axios'

import { TPriceWindowApiDto } from './apiBinance.types'
import { fetchWithCache } from './api'

const BINANCE_API_URL = 'https://api1.binance.com/api/v3'

const requestGetPriceWindow = async ({
    pairName,
}: {
    pairName: string
}): TAsyncRequestResult<TPriceWindowApiDto> => {
    let params = ''
    if (pairName) params = `symbol=${pairName}`

    return resolveRequest<TPriceWindowApiDto>(axios.get(`${BINANCE_API_URL}/ticker/24hr?${params}`))
}

const requestGetPricesWindow = async ({
    currencies,
}: {
    currencies: string[]
}): TAsyncRequestResult<TPriceWindowApiDto[]> => {
    let params = ''
    if (currencies) params = `symbols=[${currencies.map((currency) => `"${currency}USDT"`).join(',')}]`
    return fetchWithCache<TPriceWindowApiDto[]>(`${BINANCE_API_URL}/ticker/24hr?${params}`, 1)
}

export { requestGetPriceWindow, requestGetPricesWindow }
